module.exports = __webpack_public_path__ + "img/108001.0d07016f.png";